import React from 'react';
import { cnHeaderIcon } from '../Header.const';
import './Header-Icons.css';
/**
 * Компонент-хелпер для сборки иконок для шапки через background-image.
 * @param {BaseIconProps} props
 *
 */
export var BaseIcon = function (_a) {
    var className = _a.className, cn = _a.cn;
    return (React.createElement("span", { className: cn(null, [cnHeaderIcon, className]) }));
};
